import React from 'react';
import FadeIn from 'react-fade-in';
import styled from 'styled-components';
import { AccountInfo } from './components/accountTable';
import { MovementsTable } from './components/movementsTable';

const BackgroundContainer = styled.div`
  flex: 1;
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  margin: 1rem;
`;

export const Movements = () => (
  <BackgroundContainer>
    <Container>
      <FadeIn>
        <AccountInfo />
        <MovementsTable />
      </FadeIn>
    </Container>
  </BackgroundContainer>
);
